export default __webpack_public_path__ + "static/media/clickTips.50ed951b.svg";